/*
 * @Author: NarutoTuT a110588@icloud.com
 * @Date: 2025-05-14 09:09:55
 * @LastEditors: NarutoTuT a110588@icloud.com
 * @LastEditTime: 2026-02-03 11:31:31
 * @FilePath: \demo-myshopify-com\assets\sections.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/*
  © 2024 KondaSoft
  
*/

class Navbar extends HTMLElement {
  constructor () {
    super()

    this.handleDropdownsBackdrop()
    this.handleHeaderReveal()
    this.adjustOffcanvasMenu()
    this.handleStickyNavbar()
  }

  handleStickyNavbar () {
    const navbar = this
    let lastScroll = 0

    window.addEventListener('scroll', () => {
      const currentScroll = window.scrollY

      if (currentScroll > 0) {
        navbar.classList.add('navbar-sticky')
      } else {
        navbar.classList.remove('navbar-sticky')
      }

      lastScroll = currentScroll
    })
  }

  adjustOffcanvasMenu () {
    const offcanvasMenu = document.querySelector('#offcanvas-menu')
    const navbarMobile = document.querySelector('#navbar-mobile')

    offcanvasMenu?.addEventListener('show.bs.offcanvas', () => {
      const navbarSpacing = document.querySelector('#navbar-mobile').getBoundingClientRect().bottom
      offcanvasMenu.style.height = `${window.innerHeight - navbarSpacing}px`

      navbarMobile.querySelector('.svg-icon-menu')?.classList.add('svg-icon-menu-close')
    })

    offcanvasMenu?.addEventListener('hide.bs.offcanvas', () => {
      navbarMobile.querySelector('.svg-icon-menu')?.classList.remove('svg-icon-menu-close')
    })
  }

  handleHeaderReveal () {
    let oldScroll = window.scrollY
    const headerGroup = document.querySelector('#header-group')

    window.addEventListener('scroll', () => {
      const newScroll = window.scrollY
      if (newScroll > oldScroll) {
        if (newScroll > headerGroup.clientHeight) {
          headerGroup.classList.add('hide')
        }
      } else if (newScroll < oldScroll) {
        headerGroup.classList.remove('hide')
      }

      oldScroll = Math.max(window.scrollY, 0)
    })
  }

handleDropdownsBackdrop () {
  this.querySelectorAll('#navbar-desktop .dropdown').forEach(dropdown => {
    const toggle = dropdown.querySelector('.dropdown-toggle')
    const menu = dropdown.querySelector('.dropdown-menu')
    let hideTimeout = null

    dropdown.addEventListener('mouseenter', () => {
      clearTimeout(hideTimeout) // 防止之前设置的隐藏触发
      menu.setAttribute('data-bs-popper', 'static')
      dropdown.classList.add('show')
      menu.classList.add('show')
      document.body.classList.add('navbar-dropdown-open')
    })

    dropdown.addEventListener('mouseleave', () => {
      // 设置延迟隐藏
      hideTimeout = setTimeout(() => {
        menu.removeAttribute('data-bs-popper')
        dropdown.classList.remove('show')
        menu.classList.remove('show')

        if (!document.querySelector('#navbar-desktop .dropdown.show')) {
          document.body.classList.remove('navbar-dropdown-open')
        }
      }, 300) // 300ms 延迟，可按需调整
    })
  })
}



}
customElements.define('navbar-wrapper', Navbar)
